import { render, staticRenderFns } from "./UcMeterHeatmap.yaml?vue&type=template&id=2ff8134d&component"
import script from "./UcMeterHeatmap.yaml?vue&type=script&lang=ts&component"
export * from "./UcMeterHeatmap.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports